import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '@/components/layout/PageHeader';
import {
  OrganizationSection,
  PersonalSection,
  ProfileLayout,
} from '@/features/users/components/profile';
import { profileQueryOptions } from '../api/auth.api';
import { ChangePasswordForm } from './ChangePasswordForm';

export function ProfilePage() {
  const { data: user, isLoading, error } = useQuery(profileQueryOptions);

  if (error) throw error;
  if (!isLoading && !user) return null;

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="Profile" />
      <ProfileLayout user={user}>
        <OrganizationSection user={user} />
        <PersonalSection user={user} />
        <ChangePasswordForm />
      </ProfileLayout>
    </div>
  );
}
